import React from "react";
import { useFormContext } from "react-hook-form";
import { SelectField } from "../../shared/form-fields/select-field";
import { quotationPopupFormDefinition } from "../constants/form-fields-definition";
import { RANGE_OF_EMPLOYEES_AS_OPTIONS } from "../../../constants/enums/range-of-employees";

export const QuotationPopupDocumentRangeOfEmployees: React.FC = () => {
    const rhForm = useFormContext();
    return (
        <div data-testid="QuotationPopupDocumentRangeOfEmployees">
            <SelectField
                rhForm={rhForm}
                fieldDefinition={quotationPopupFormDefinition.rangeOfEmployees}
                options={RANGE_OF_EMPLOYEES_AS_OPTIONS}
            />
        </div>
    );
};
